

const SpLabel = ({children, htmlFor}) => {
    return (<label htmlFor={htmlFor} className="sp-label">{children}</label>);
}

export default SpLabel;